class NorthportHeaderNavigation {
  constructor() {
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.desktopMenus = Array.from(document.querySelectorAll('[data-northport-dropdown]'));
    this.mobileToggles = Array.from(document.querySelectorAll('.northport-menu-drawer__toggle'));
    this.mobileDrawerLinks = Array.from(document.querySelectorAll('#menu-drawer a[href]'));

    this.bindDesktopMenus();
    this.bindMobileAccordions();
    this.bindMobileDrawerLinks();
    document.addEventListener('pointerdown', this.onDocumentPointerDown.bind(this));
  }

  bindDesktopMenus() {
    this.desktopMenus.forEach((menu) => {
      const parentLink = menu.querySelector(':scope > [data-northport-parent-link]');
      const toggle = menu.querySelector(':scope > .northport-header__submenu-toggle');
      const panelId = toggle?.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!parentLink || !toggle || !panel) return;

      let closeTimer;
      const cancelClose = () => window.clearTimeout(closeTimer);
      const open = () => {
        cancelClose();
        this.closeDesktopMenus(menu);
        menu.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/^Open /, 'Close '));
        panel.setAttribute('aria-hidden', 'false');
      };
      const close = ({ restoreFocus = false } = {}) => {
        cancelClose();
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/^Close /, 'Open '));
        panel.setAttribute('aria-hidden', 'true');
        if (restoreFocus) toggle.focus();
      };

      toggle.addEventListener('click', () => {
        if (menu.classList.contains('is-open')) close();
        else open();
      });

      menu.addEventListener('pointerenter', () => {
        if (this.hoverQuery.matches) open();
      });

      menu.addEventListener('pointerleave', () => {
        if (!this.hoverQuery.matches) return;
        closeTimer = window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) close();
        }, 140);
      });

      menu.addEventListener('focusin', cancelClose);
      parentLink.addEventListener('focus', open);
      menu.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) close();
        });
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !menu.classList.contains('is-open')) return;
        event.preventDefault();
        close({ restoreFocus: true });
      });
    });
  }

  closeDesktopMenus(exceptMenu = null) {
    this.desktopMenus.forEach((menu) => {
      if (menu === exceptMenu) return;
      const toggle = menu.querySelector(':scope > .northport-header__submenu-toggle');
      const panelId = toggle?.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      menu.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      if (toggle?.getAttribute('aria-label')) {
        toggle.setAttribute('aria-label', toggle.getAttribute('aria-label').replace(/^Close /, 'Open '));
      }
      panel?.setAttribute('aria-hidden', 'true');
    });
  }

  bindMobileAccordions() {
    this.mobileToggles.forEach((toggle) => {
      const panelId = toggle.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      toggle.addEventListener('click', () => {
        const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
        this.closeMobileAccordions(toggle);
        toggle.setAttribute('aria-expanded', String(shouldOpen));
        panel.hidden = !shouldOpen;
      });
    });

    document.querySelectorAll('.menu-drawer-container > details').forEach((drawer) => {
      drawer.addEventListener('toggle', () => {
        if (!drawer.open) this.closeMobileAccordions();
      });
    });
  }

  closeMobileAccordions(exceptToggle = null) {
    this.mobileToggles.forEach((toggle) => {
      if (toggle === exceptToggle) return;
      const panelId = toggle.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  bindMobileDrawerLinks() {
    this.mobileDrawerLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (
          event.defaultPrevented
          || event.button !== 0
          || event.metaKey
          || event.ctrlKey
          || event.shiftKey
          || event.altKey
          || link.target === '_blank'
          || link.hasAttribute('download')
        ) return;

        const drawer = link.closest('header-drawer');
        const openDetails = drawer?.querySelector(':scope > details[open]');
        const summary = openDetails?.querySelector(':scope > summary');
        if (!drawer || !summary || typeof drawer.closeMenuDrawer !== 'function') return;

        this.closeMobileAccordions();
        summary.setAttribute('aria-expanded', 'false');
        drawer.closeMenuDrawer(event, summary);
      });
    });
  }

  onDocumentPointerDown(event) {
    if (this.desktopMenus.some((menu) => menu.contains(event.target))) return;
    this.closeDesktopMenus();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new NorthportHeaderNavigation(), { once: true });
} else {
  new NorthportHeaderNavigation();
}
